<div class="page-container">
  <intelishs-page-header title="Solicitar Vacaciones" [subtitle]="subtituloPagina()" />

  <!-- Selector administrativo: solo visible para Admin/RH. Empleado/Director
       se autoseleccionan vía /api/Empleado/me en ngOnInit y este bloque queda
       oculto. -->
  @if (puedeSeleccionarOtro()) {
    <div class="employee-selector">
      <nz-icon nzType="info-circle" class="text-muted" />
      <small class="text-muted">
        Alta administrativa — selecciona el empleado al que aplicará esta solicitud
      </small>
      <nz-select
        style="width: 100%; margin-top: 8px"
        nzShowSearch
        nzPlaceHolder="Seleccionar empleado"
        [ngModel]="selectedEmpleadoId()"
        (ngModelChange)="onEmpleadoChange($event)"
      >
        @for (emp of empleados(); track emp.id) {
          <nz-option [nzValue]="emp.id" [nzLabel]="emp.idInterno + ' - ' + emp.nombreCompleto" />
        }
      </nz-select>
    </div>
  }

  @if (saldo(); as s) {
    <!-- ══ BLOQUEADO: aún no cumple 6 meses ══════════════════════════════ -->
    @if (!s.desbloqueado) {
      <div class="saldo-bloqueado">
        <nz-icon nzType="lock" style="font-size: 32px; color: #8c8c8c" />
        <div>
          <strong>Vacaciones no disponibles aún</strong>
          <p style="margin: 4px 0 0">
            Las vacaciones se desbloquean a los 6 meses de antigüedad. Disponibles a partir del
            <strong>{{ s.fechaDesbloqueo | date: 'dd/MM/yyyy' }}</strong
            >.
          </p>
          <p style="margin: 4px 0 0; color: #8c8c8c; font-size: 12px">
            Antigüedad actual: {{ s.mesesAntiguedad }} meses
          </p>
        </div>
      </div>
    }

    <!-- ══ DESBLOQUEADO ═══════════════════════════════════════════════════ -->
    @if (s.desbloqueado) {
      <!-- Alerta saldo negativo -->
      @if (s.tieneSaldoNegativo) {
        <div class="vac-alerta vac-alerta--negativo">
          <nz-icon nzType="warning" />
          <span>
            Saldo negativo de <strong>{{ s.diasNegativo | number: '1.1-1' }} días</strong>. Se
            compensará con días generados en el futuro.
          </span>
        </div>
      }

      <!-- Alerta de vencimiento del ciclo anterior -->
      @if (periodoAnterior(); as pa) {
        @if (urgenciaPorVencer() === 'critico') {
          <div class="vac-alerta vac-alerta--critico">
            <nz-icon nzType="fire" />
            <span>
              ¡Atención! Tienes
              <strong>{{ pa.diasDisponibles | number: '1.1-1' }} días</strong> que vencen en
              <strong>{{ diasHastaVencimiento() }} días</strong> ({{
                pa.fechaVencimiento | date: 'dd/MM/yyyy'
              }}). Úsalos antes de perderlos.
            </span>
          </div>
        } @else if (urgenciaPorVencer() === 'advertencia') {
          <div class="vac-alerta vac-alerta--advertencia">
            <nz-icon nzType="clock-circle" />
            <span>
              Tienes <strong>{{ pa.diasDisponibles | number: '1.1-1' }} días</strong> del ciclo
              anterior que vencen el
              <strong>{{ pa.fechaVencimiento | date: 'dd/MM/yyyy' }}</strong> ({{
                diasHastaVencimiento()
              }}
              días). Úsalos antes de esa fecha.
            </span>
          </div>
        } @else {
          <div class="vac-alerta vac-alerta--info">
            <nz-icon nzType="info-circle" />
            <span>
              Tienes <strong>{{ pa.diasDisponibles | number: '1.1-1' }} días</strong> del ciclo
              anterior disponibles hasta el
              <strong>{{ pa.fechaVencimiento | date: 'dd/MM/yyyy' }}</strong
              >.
            </span>
          </div>
        }
      }

      <!-- ── Respuesta primero: cuántos días puede pedir hoy ──────────
           Antes este total vivía abajo, en un KPI del mismo tamaño que dos
           ceros, y había que sumar mentalmente los dos ciclos para llegar a
           él. Es LA pregunta que trae al empleado, así que abre la pantalla y
           el desglose queda como contexto. -->
      <!-- El total del backend es A HOY: con una solicitud a futuro queda
           negativo aunque se cubra a su fecha. Eso no es deuda, y se lee como
           "0 hoy" para no alarmar; la deuda real la marca tieneSaldoNegativo. -->
      <div class="saldo-total" [class.saldo-total--negativo]="lecturaSaldo()?.tipo === 'deuda'">
        <div class="saldo-total-cabecera">
          <div class="saldo-total-cifra">
            @switch (lecturaSaldo()?.tipo) {
              @case ('deuda') {
                <span class="saldo-total-lbl">Saldo negativo</span>
                <span class="saldo-total-val">
                  {{ s.diasNegativo | number: '1.1-1' }}
                  <span class="saldo-total-unidad">días</span>
                </span>
              }
              @case ('comprometido') {
                <span class="saldo-total-lbl">Disponibles hoy</span>
                <span class="saldo-total-val">
                  0 <span class="saldo-total-unidad">días</span>
                </span>
              }
              @default {
                <span class="saldo-total-lbl">Tienes disponibles</span>
                <span class="saldo-total-val">
                  {{ s.diasDisponiblesTotal | number: '1.1-1' }}
                  <span class="saldo-total-unidad">días</span>
                </span>
              }
            }
          </div>

          <!-- La acción de la pantalla, junto al dato que la motiva -->
          <!-- nz-button es obligatorio: las clases del theme solo definen
               colores y se apoyan en la base .ant-btn de ng-zorro. -->
          <button
            nz-button
            type="button"
            class="sinay-outline-reset saldo-total-cta"
            [disabled]="bloqueoNuevaSolicitud() !== null"
            nz-tooltip
            [nzTooltipTitle]="bloqueoNuevaSolicitud() ?? ''"
            (click)="abrirNuevaSolicitud()"
          >
            <nz-icon nzType="plus" />
            Solicitar vacaciones
          </button>
        </div>

        <!-- De dónde salen esos días, en una línea legible -->
        <div class="saldo-total-desglose">
          @if (periodoAnterior(); as pa) {
            <span class="saldo-total-parte">
              <strong>{{ pa.diasDisponibles | number: '1.1-1' }}</strong>
              vencen el {{ pa.fechaVencimiento | date: 'dd/MM/yyyy' }}
            </span>
          }
          @if (periodoActual(); as pc) {
            @if (pc.diasDisponibles >= 0) {
              <span class="saldo-total-parte">
                <strong>{{ pc.diasDisponibles | number: '1.1-1' }}</strong>
                del ciclo actual
              </span>
            }
          }
          @if (lecturaSaldo(); as l) {
            @if (l.tipo === 'comprometido') {
              <span class="saldo-total-parte saldo-total-parte--espera">
                <strong>{{ l.aFuturo | number: '1.1-1' }}</strong> pedidos a cuenta de lo que
                generes antes de esas fechas
              </span>
            }
          }
          @if (diasEnEspera() > 0) {
            <span class="saldo-total-parte saldo-total-parte--espera">
              <strong>{{ diasEnEspera() }}</strong> en espera de aprobación
            </span>
          }
          @if (diasAprobadosFuturos() > 0) {
            <span class="saldo-total-parte saldo-total-parte--aprobado">
              <strong>{{ diasAprobadosFuturos() }}</strong> ya aprobados
            </span>
          }
        </div>

        <!-- Qué va a pasar después de pedir. El empleado entra pocas veces al
             año: sin esto, "Pendiente" no le dice de quién depende su
             solicitud ni cuántos pasos faltan. -->
        <div class="saldo-pasos">
          <span class="saldo-paso">
            <span class="saldo-paso-num">1</span>
            Eliges tus fechas
          </span>
          <span class="saldo-paso-sep">→</span>
          <span class="saldo-paso">
            <span class="saldo-paso-num">2</span>
            Tu director las revisa
          </span>
          <span class="saldo-paso-sep">→</span>
          <span class="saldo-paso">
            <span class="saldo-paso-num">3</span>
            RH confirma
          </span>
          <span class="saldo-paso-sep">·</span>
          <span class="saldo-paso">Pide con 2 semanas de anticipación</span>
        </div>
      </div>

      <!-- ── Detalle por ciclo ────────────────────────────────────────
           Las dos tarjetas comparten esqueleto (encabezado, dato grande,
           vigencia, desglose) para que se puedan comparar de un vistazo. Un
           solo número destacado por tarjeta: el resto es contexto en gris. -->
      <div class="saldo-bloques">
        @if (cicloAnterior(); as pa) {
          <div class="ciclo">
            <div class="ciclo-head">
              <span class="ciclo-titulo">Ciclo anterior</span>
              <span class="ciclo-estado">
                @if (pa.diasDisponibles <= 0) {
                  <span class="status-dot ciclo-dot--vencido"></span>
                  Agotado
                } @else if (urgenciaPorVencer() === 'critico') {
                  <span class="status-dot ciclo-dot--critico"></span>
                  Vence pronto
                } @else if (urgenciaPorVencer() === 'advertencia') {
                  <span class="status-dot ciclo-dot--advertencia"></span>
                  Por vencer
                } @else {
                  <span class="status-dot ciclo-dot--vigente"></span>
                  Vigente
                }
              </span>
            </div>

            <div class="ciclo-dato">
              <span
                class="ciclo-val"
                [class.ciclo-val--critico]="urgenciaPorVencer() === 'critico'"
                >{{ pa.diasDisponibles | number: '1.1-1' }}</span
              >
              <span class="ciclo-unidad">días disponibles</span>
            </div>

            <div class="ciclo-vigencia">
              Vence el <strong>{{ pa.fechaVencimiento | date: 'dd/MM/yyyy' }}</strong>
              @if (diasHastaVencimiento() !== null) {
                · {{ diasHastaVencimiento() }} días restantes
              }
            </div>

            <div class="ciclo-desglose">
              {{ pa.diasCorrespondientes }} por ley ·
              {{ pa.diasGenerados | number: '1.1-1' }} generados ·
              {{ pa.diasUsados | number: '1.1-1' }} usados
            </div>

            @if (pa.diasDisponibles > 0) {
              <div class="ciclo-nota">Tus próximas vacaciones se descuentan primero de aquí</div>
            } @else {
              <div class="ciclo-nota">Ya usaste todos los días de este ciclo</div>
            }
          </div>
        }

        @if (periodoAnteriorVencido(); as pa) {
          <div class="ciclo">
            <div class="ciclo-head">
              <span class="ciclo-titulo">Ciclo anterior</span>
              <span class="ciclo-estado">
                <span class="status-dot ciclo-dot--vencido"></span>
                Vencido
              </span>
            </div>

            <div class="ciclo-dato">
              <span class="ciclo-val ciclo-val--apagado">0</span>
              <span class="ciclo-unidad">días disponibles</span>
            </div>

            <div class="ciclo-vigencia">
              Venció el <strong>{{ pa.fechaVencimiento | date: 'dd/MM/yyyy' }}</strong>
            </div>

            <div class="ciclo-desglose">
              {{ pa.diasCorrespondientes }} por ley ·
              {{ pa.diasGenerados | number: '1.1-1' }} generados ·
              {{ pa.diasUsados | number: '1.1-1' }} usados
            </div>
          </div>
        }

        @if (periodoActual(); as pc) {
          <div class="ciclo">
            <div class="ciclo-head">
              <span class="ciclo-titulo">Ciclo actual</span>
              <span class="ciclo-estado">
                <span class="status-dot ciclo-dot--acumulando"></span>
                Acumulando
              </span>
            </div>

            <div class="ciclo-dato">
              <span class="ciclo-val">{{ pc.diasDisponibles | number: '1.1-1' }}</span>
              <span class="ciclo-unidad">días disponibles</span>
            </div>

            <div class="ciclo-progreso">
              <div
                class="ciclo-progreso-fill"
                [style.width.%]="
                  pc.diasCorrespondientes > 0
                    ? (pc.diasGenerados / pc.diasCorrespondientes) * 100
                    : 0
                "
              ></div>
            </div>

            <div class="ciclo-vigencia">
              Llevas <strong>{{ pc.diasGenerados | number: '1.1-1' }}</strong> de
              {{ pc.diasCorrespondientes }} · aniversario
              {{ pc.fechaAniversario | date: 'dd/MM/yyyy' }}
            </div>

            <div class="ciclo-desglose">
              {{ pc.diasCorrespondientes }} por ley ·
              {{ pc.diasGenerados | number: '1.1-1' }} generados ·
              {{ pc.diasUsados | number: '1.1-1' }} usados
            </div>
          </div>
        }
      </div>

      @if (solicitudesEnProceso().length > 0) {
        <div class="pendiente-aviso">
          <nz-icon nzType="clock-circle" style="color: #fa8c16; margin-right: 5px" />
          {{ textoEnProceso() }}
        </div>
      }
    }

    <!-- My Requests Table -->
    <!-- Segunda entrada a "Solicitar vacaciones", para no tener que subir hasta la
         tarjeta de saldo desde la tabla. Mismo bloqueo y mismo tooltip que el botón
         de arriba: los dos leen bloqueoNuevaSolicitud(). -->
    <intelishs-data-table
      [data]="solicitudesVisibles()"
      [columns]="columns"
      [loading]="loading()"
      [searchable]="false"
      [pageSize]="10"
      [showRefreshButton]="true"
      [showAddButton]="true"
      [disableAddButton]="bloqueoNuevaSolicitud() !== null"
      [addButtonTooltip]="bloqueoNuevaSolicitud() ?? 'Solicitar vacaciones'"
      (refresh)="recargar()"
      (add)="abrirNuevaSolicitud()"
    >
      <!-- Periodo: el rango se lee junto y los días hábiles dan el contexto -->
      <ng-template intelishsCellTemplate="fechaInicio" let-row>
        <intelishs-cell-stack
          [main]="
            (row.fechaInicio | date: 'dd/MM/yyyy') + ' → ' + (row.fechaFin | date: 'dd/MM/yyyy')
          "
          [meta]="
            row.diasSolicitados + (row.diasSolicitados === 1 ? ' día hábil' : ' días hábiles')
          "
        />
      </ng-template>

      <ng-template intelishsCellTemplate="acciones" let-row>
        <intelishs-table-actions
          [row]="row"
          [actions]="getActionsForRow(row)"
          (action)="onAction({ action: $event, row })"
        />
      </ng-template>
    </intelishs-data-table>
  }
</div>

<!-- Modal nueva solicitud -->
<app-solicitud-nueva-modal
  [(visible)]="nuevaModalVisible"
  [empleadoId]="selectedEmpleadoId()"
  [saldo]="saldo()"
  (saved)="onNuevaGuardada()"
/>

<!-- Modal resolución (vista del empleado) -->
<app-solicitud-resolucion-modal [(visible)]="resolVisible" [solicitud]="resolSolicitud()" />

<!-- Modal edición de solicitud -->
<app-solicitud-editar-modal
  [(visible)]="editModalVisible"
  [solicitud]="editSolicitud()"
  (saved)="onEditarGuardado()"
/>
